import React from 'react';
import { X, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const ServiceModal = ({ service, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative z-10 bg-white rounded-sm max-w-3xl w-full mx-4 max-h-[90vh] overflow-y-auto transform transition-all duration-300 animate-fade-in">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-10 h-10 bg-black hover:bg-gray-800 rounded-sm flex items-center justify-center transition-all duration-300 z-10"
        >
          <X className="text-white" size={20} />
        </button>

        {/* Image */}
        <div className="relative h-80 overflow-hidden">
          <img
            // src="/services/cad-modeling.png"
              src={service.image}
            alt={service.title}
            className="w-full h-full object-cover"
            // style={{ filter: 'grayscale(100%)' }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
          <h2 className="absolute bottom-6 left-6 text-4xl font-bold text-white tracking-wide">
            {service.title}
          </h2>
        </div>

        {/* Content */}
        <div className="p-8">
          <h3 className="text-2xl font-bold text-black mb-4">Overview</h3>
          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            {service.description}
          </p>

          <h3 className="text-2xl font-bold text-black mb-4">What We Offer</h3>
          <ul className="space-y-3 mb-8">
            {service.offerings?.map((offering, index) => (
              <li key={index} className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-black rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-700 text-base">{offering}</span>
              </li>
            ))}
          </ul>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg"
              className="bg-black text-white hover:bg-gray-800 transition-all duration-300 flex-1"
            >
              Connect With Us
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button 
              size="lg"
              variant="outline"
              onClick={onClose}
              className="border-black text-black hover:bg-gray-100 transition-all duration-300 flex-1"
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;
